import produce from "immer";
import {ICarePractitionerActionDto} from "doctors-dashboard/http-clients/index";
import {CarePractitionerActionActions} from "./care-practitioner-action.actions";
import {OperationErrorType, StoreAction} from "orpyx-web-common";

export interface CarePractitionerActionState {
    initialized: boolean;
    actions: ICarePractitionerActionDto[];
    error: OperationErrorType;
}

const initialState: CarePractitionerActionState = {
    initialized: false,
    actions: [],
    error: undefined,
};

const CarePractitionerActionReducers = (state = initialState, action: StoreAction<CarePractitionerActionActions>): CarePractitionerActionState => {
    return produce(state, (draft: CarePractitionerActionState) => {
        switch (action.type) {
            case CarePractitionerActionActions.FETCH_CARE_PRACTITIONER_ACTIONS:
                draft.initialized = false;
                draft.error = undefined;
                draft.actions = [];
                break;

            case CarePractitionerActionActions.FETCH_CARE_PRACTITIONER_ACTIONS_SUCCESSFULLY:
                draft.initialized = true;
                const orderedActionIds = [
                    9, 10, 11, 12, 13, // Clinical Review (Phone Or Text, Success or Failure, or No contact)
                    20, // Inbound Clinical Information
                    14, 15, // Provider Escalation, Provider Update
                    16, // Patient Education / Onboarding
                    22, 23, 24, 25, // Monthly Clinical Review
                    21, // Monthly Report Distribution
                    26, // Clinical Rounds
                    17, // In-person encounter
                    18, 19 // Data integrity review initiation and resolution
                ];
                const rank = Object.fromEntries( orderedActionIds.map((id, index) => [id, index]));
                const sortedItems = [...action.payload].sort((a, b) => {
                  const rankA = rank[a.id] ?? Infinity;
                  const rankB = rank[b.id] ?? Infinity;

                  if (rankA !== rankB) {
                    return rankA - rankB;
                  }
              
                  // Both items are unranked (or have same rank)
                  return a.id - b.id;
                });

                draft.actions = sortedItems;
                draft.error = undefined;
                break;

            case CarePractitionerActionActions.FETCH_CARE_PRACTITIONER_ACTIONS_FAILED:
                draft.initialized = false;
                draft.error = action.payload;
                draft.actions = [];
                break;
        }
    });
};

export default CarePractitionerActionReducers;
